import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IUserConfiguration } from './user.reducer';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http$: HttpClient) { }

  getUserConfiguration() {
    return this.http$.get<IUserConfiguration>('/api/userconfiguration');
  }
}